import { ref } from "vue";
import { ElMessage } from "element-plus";

export default ({ checkedList }) => {
    const show = ref(false);

    function open() {
        if (!checkedList.value.length) {
            ElMessage.error("请选择需要发送的文章");
            return;
        }
        show.value = true;
    }

    function close() {
        show.value = false;
    }

    return { show, open, close };
};
